import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {RouterModule} from '@angular/router';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import {AngularFireModule} from 'angularfire2';
import {environment} from '../environments/environment';
import {AngularFireDatabaseModule} from 'angularfire2/database';
import {AngularFireAuthModule} from 'angularfire2/auth';
import {UserRepo} from './DAL/usersRepo';
import {TranslationSharedModule} from './translation/translationSharedModule';
import {AppRoutingModule} from './app.routing';
import {LayoutModule} from './layouts/layoute.module';
import {ToasterModule} from 'angular2-toaster';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AuthGuard} from './auth/auth-guard.service';
import {DownloadToasterComponent} from "./shared/download-toaster.component";
import {CloudFunctionHttpClient} from "./base/service/CloudFunctionHttpClient";

@NgModule({
  declarations: [
    AppComponent,
    DownloadToasterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    RouterModule,
    LayoutModule,
    ToasterModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    TranslationSharedModule,
    NgbModule.forRoot(),
  ],
  entryComponents: [DownloadToasterComponent],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    UserRepo,
    AuthGuard,
    CloudFunctionHttpClient
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/app.module.ts